import './TrialLinks.sass';

import React, { FC, useEffect } from 'react';
import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { IcLink28 } from '$assets';
import { showModal } from '$navigation/helper';
import { TrialLink } from '$core/TrialLinks/TrialLink/TrialLink';
import { useDispatch, useSelector } from 'react-redux';
import { trialLinksActions, trialLinksSelector } from '$store/trialLinks';
import { Loader } from '$shared/components';
import { useTranslator } from '$hooks';

export const TrialLinks = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { links, isLinksLoading } = useSelector(trialLinksSelector);

  useEffect(() => {
    dispatch(trialLinksActions.loadLinks());
  }, []);

  return (
    <>
      <Header showBackButton>{t('trial_links_title')}</Header>
      <ScrollView
        footer={
          <div>
            <Button onClick={() => showModal('create_trial_link')}>
              {t('trial_links_create_new_link')}
            </Button>
          </div>
        }
      >
        {isLinksLoading ? (
          <Loader isWrapped />
        ) : links.length ? (
          links.map((link) => <TrialLink key={link.id} link={link} />)
        ) : (
          <Placeholder
            centered
            className="TrialLinks__emptyPlaceholder"
            title={t('trial_links_placeholder_title')}
            icon={<IcLink28 />}
            iconSize={80}
          >
            {t('trial_links_placeholder_desc')}
          </Placeholder>
        )}
      </ScrollView>
    </>
  );
};
